Ciao! Ecco le informazioni essenziali sulla prova che stai per svolgere. Ti consigliamo di leggerle attentamente.

## Regole di base

Ti è permesso:

- avere a disposizione una calcolatrice (di qualunque tipo, comprese quelle grafiche);
- avere con te dei fogli bianchi (eventualmente a righe o quadretti);
- avere con te del materiale di cancelleria (penne, matite, gomma, etc.);
- andare in bagno (senza dispositivi elettronici o materiale cartaceo);
- comunicare con il docente sorvegliante in caso di problemi tecnici.

Non ti è permesso:

- se gareggi online, **uscire dalla piattaforma di gara** per qualsiasi motivo;
- comunicare con i tuoi compagni;
- comunicare con il docente sorvegliante sul contenuto della prova;
- diffondere il testo della prova, o parte di esso, prima delle ore 20 dell'ultimo giorno di prova (11 dicembre).

## Formato della prova

La prova contiene _10 problemi_ da risolvere in _90 minuti_, ed è divisa in due parti:
- sei problemi di **pensiero logico-algoritmico**, e
- quattro problemi di interpretazione di **programmi** in pseudocodice o a blocchi.

In entrambe le parti i problemi sono **in ordine casuale**.
Ogni problema comprende _due domande_, valutate separatamente.
La prima è **sempre più semplice**, e può aiutare a rispondere alla seconda (che è solitamente difficile).

## Punteggio

Le domande possono essere a **risposta aperta** numerica; oppure a **scelta multipla** con cinque opzioni, di cui **solo una** è corretta.
In ogni caso, il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.

## Quesiti di programmazione e pseudocodice

I quesiti di programmazione presentano semplici programmi scritti in _pseudocodice_. Qui sotto puoi trovare un riassunto della sintassi dello pseudocodice, oppure [scarica qui la guida completa](/Pseudocodice.pdf) in PDF.
**Quest'anno, per la prima volta, i quesiti di programmazione verranno proposti anche come programma a blocchi:** potrai scegliere di guardare una versione, l'altra o entrambe, a seconda di come ti può essere più congeniale.

![Riassunto guida pseudocodice](pseudocodice-cheatsheet.svg)
